import { getUser } from "$lib/userstorage/usersotrage"
import { handleAuthenticatedRequest, jsonOrThrow } from "../errores/erroresback"
import { queryClient, cacheRestored } from "$lib/query/queryClient"
import { queryKeys } from "$lib/query/keys"
import { loadStorageEstablecimiento } from "$lib/java/establecimientos/establecimientostorage"
let ruta_java = import.meta.env.VITE_RUTA_JAVA_SERVER;
let ruta_local_java = import.meta.env.VITE_RUTA_LOCAL_JAVA_SERVER;
let bd_local = import.meta.env.VITE_LOCAL_BD == "si";
let RUTA_JAVA = bd_local ? ruta_local_java : ruta_java;
const RUTA_NACIMIENTOS = "births"
function processNacimiento(birth) {
    let data_nacimiento = {
        id: birth.birthId,
        idanimal: birth.animalId,
        fecha: birth.date,
        caravana: birth.animalTagNumber,
        madre: birth.motherId,
        padre: birth.fatherId,
        nombremadre: birth.motherTagNumber,
        nombrepadre: birth.fatherTagNumber,
        externalFatherTag: birth.externalFatherTag ?? "",
        observacion: birth.notes ? birth.notes : "",
        cab: birth.establishmentId,
        expadnd: {
            madre: {
                id: birth.motherId,
                nombre: birth.motherTagNumber
            },
            padre: {
                id: birth.fatherId,
                nombre: birth.fatherTagNumber
            },
        }
    }
    return data_nacimiento
}
export function processNacimientos(data) {
    let data_nacimientos = []
    for (let i = 0; i < data.length; i++) {
        let fila = data[i]
        data_nacimientos.push(processNacimiento(fila))
    }
    return data_nacimientos
}
function isRealError(err) {
    return !!err && (err.message === "SESIÓN_EXPIRADA" || err.message === "SIN_PERMISO" || typeof err.status === "number")
}
export async function getAll(cabid = null) {
    let user = getUser();
    let token = user.token;

    let ruta = `${RUTA_JAVA}${RUTA_NACIMIENTOS}/all`
    let url = new URL(ruta)
    if (cabid) {
        url.searchParams.append('establishmentId', cabid);
    }
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    try {
        let res_all = await handleAuthenticatedRequest(url.toString(), options)

        let data_all = await jsonOrThrow(res_all, "nacimientos.getAll")

        return processNacimientos(data_all)
    } catch (err) {
        if (isRealError(err)) throw err
        await cacheRestored
        const cached = cabid ? queryClient.getQueryData(queryKeys.births(cabid)) : null
        if (Array.isArray(cached)) return cached
        throw err
    }
}
// Fallback offline: el detalle del nacimiento no se cachea individualmente, pero
// la lista sí (queryKeys.births, sembrada por el snapshot) y comparte el shape de
// processNacimiento. Buscar por id ahí cuando no hay red.
function findBirthInCache(id) {
    try {
        const estId = loadStorageEstablecimiento()?.id
        if (estId == null || estId === "") return null
        const lista = queryClient.getQueryData(queryKeys.births(estId))
        if (Array.isArray(lista)) {
            const found = lista.find((b) => String(b.id) === String(id))
            if (found) return found
        }
        return null
    } catch (e) {
        return null
    }
}
export async function getBirthId(id) {
    let ruta = `${RUTA_JAVA}${RUTA_NACIMIENTOS}/${id}`
    let user = getUser();
    let token = user.token;
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    try {
        let res_all = await fetch(ruta, options)
        let data_all = await res_all.json()
        return processNacimiento(data_all)
    } catch (err) {
        // Red caida (offline): servir el nacimiento desde el cache de la lista, para
        // que /nacimientos/{id} cargue (y con él el animalOriginal de la cría). Si no
        // está, re-lanzo: el caller (loadNacimiento) cae a lo cacheado en su proxy.
        await cacheRestored
        const cached = findBirthInCache(id)
        if (cached) return cached
        throw err
    }
}
function postData(data, establishmentId = 1) {

    let data_nacimiento = {
        date: data.fecha.split(" ")[0],
        motherId: data.madre,
        fatherId: data.padre || null,
        externalFatherTag: !data.padre && data.externalFatherTag ? data.externalFatherTag : null,
        notes: data.observacion,
        establishmentId: data.cab,
        animalId: data.animal
    }

    return data_nacimiento

}
export async function saveBirth(data) {
    let ruta = `${RUTA_JAVA}${RUTA_NACIMIENTOS}`

    let data_birth = postData(data)


    let user = getUser();
    let token = user.token;

    let res_save = await fetch(ruta, {
        method: "POST",
        body: JSON.stringify(data_birth), // data can be `string` or {object}!
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })

    let data_save = await res_save.json()

    return data_save

}
export async function editNacimiento(id, data) {
    let ruta = `${RUTA_JAVA}${RUTA_NACIMIENTOS}/${id}`
    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "PUT",
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    if (!res_post.ok) {
        throw new Error(`Error al actualizar nacimiento: ${res_post.status}`);
    }

    let data_post = await res_post.json()
    return data_post
}
export async function eliminarNacimiento(id) {
    
    let ruta = `${RUTA_JAVA}${RUTA_NACIMIENTOS}/delete/${id}`
    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "POST",
            //            body: JSON.stringify({}), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    //let data_post = await res_post.json()
    return {}
}